export default function ($translate) {
    return {
        KEYS: {
            ONLINE: 'ONLINE',
            WEBINAR: 'WEBINAR',
            CLASSROOM: 'CLASSROOM',
            TEST: 'TEST',
            FEEDBACK: 'FEEDBACK'
        },
        LABELS: {
            ONLINE: $translate.instant('course.trainingType.Online'),
            WEBINAR: $translate.instant('course.trainingType.Webinar'),
            CLASSROOM: $translate.instant('course.trainingType.Classroom'),
            TEST: $translate.instant('course.trainingType.Test'),
            FEEDBACK: $translate.instant('course.trainingType.Feedback')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/trainingType/index.js